import React from 'react';

import { ProposalSettingsMenu } from 'components/Layouts/Form/Header/ProposalSettingsMenu';
import LandingV2 from 'detailsv2/LandingV2';
import { BurgerMenu } from 'detailsv2/LandingV2/Header/TopBar/BurgerMenu';
import LandingBuilderLayout from 'detailsv2/LandingV2/LandingBuilderLayout';
import TableOfContents from 'detailsv2/LandingV2/TableOfContents';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';
import { saveAsDOCX } from 'utils/filesDownloaders/docx';
import { saveAsPDF } from 'utils/filesDownloaders/pdf';

import ItinerariesItemActionButtons from '../../../ItinerariesItemBuilder/ActionButtons';
import BuilderPagePreview from '../../../shared/BuilderPagePreview';
import LandingActions from '../../../shared/ItinerariesItemLanding/LandingActions';
import CustomCSSV2 from './CustomCSSV2';
import {
  BlockHandlersProvider,
  iconsConfig,
  PageHandlersProvider,
  useActionButtons,
  useLandingBuilderV2,
} from './functions';

const LandingBuilderV2 = () => {
  const {
    proposal,
    links,
    activePageId,
    defaultAnchor,
    isCustomCSSV2Enabled,
    landingConfig,
    handleSetActivePageId,
    handleLandingConfigChange,
    withContentPagePreview,
    originalPagePreviewId,
  } = useLandingBuilderV2();
  const { submitting, onSave, handleSaveAsSample } = useActionButtons();
  const { isTabletOrMobile } = useMediaBreakpoints();

  return (
    <LandingBuilderLayout
      tocNavigationComponent={<TableOfContents links={links} activeLinkId={activePageId} />}
      topBarComponent={
        isCustomCSSV2Enabled ? <CustomCSSV2 config={landingConfig} onChange={handleLandingConfigChange} /> : undefined
      }
    >
      <LandingV2
        data={proposal}
        config={landingConfig}
        activePageId={activePageId}
        defaultAnchor={defaultAnchor}
        leftActions={!isTabletOrMobile && <BurgerMenu />}
        rightActions={
          !isTabletOrMobile && (
            <LandingActions icons={iconsConfig} withActionButton actionButtonOptions={proposal.actionButton} />
          )
        }
        onSetActivePageId={handleSetActivePageId}
        pageHandlersProvider={PageHandlersProvider}
        blockHandlersProvider={BlockHandlersProvider}
        readonly={false}
        isBuilder={true}
      />
      <ItinerariesItemActionButtons
        onSave={onSave}
        submitting={submitting}
        onPDF={() =>
          onSave().then(() =>
            saveAsPDF({
              item: proposal,
              itinerariesItemType: proposal.type,
            } as any),
          )
        }
        onDOCX={(themeId: string, etag: string) =>
          onSave().then(() =>
            saveAsDOCX({
              item: proposal,
              itinerariesItemType: proposal.type,
              themeId,
              etag,
            } as any),
          )
        }
        onSaveAsSample={handleSaveAsSample}
      />
      <ProposalSettingsMenu />
      {withContentPagePreview && <BuilderPagePreview pagePreviewId={originalPagePreviewId} />}
    </LandingBuilderLayout>
  );
};

export default LandingBuilderV2;
